export default function isHighstreet() {
    return (
        navigator.userAgent.match(/high ?street/gim) ||
        location.search.includes('highstreet=true')
    )
}
